import { DocumentCenterAssets } from './types/document-center.types';
import leftArrow from './assets/left-arrow.svg';
import attentionIcon from './assets/attention-icon.svg';
import headerImage from './assets/header-image.svg';
import rightChevGray from './assets/rightChevGray.svg';
import eobIcon from './assets/eob-icon.svg';
import noDocs from './assets/no-docs.svg';
import rightIndicator from './assets/right-indicator.svg';

export const DOCUMENT_CENTER_ASSETS: DocumentCenterAssets = {
  LEFT_ARROW: leftArrow,
  ATTENTION_ICON: attentionIcon,
  HEADER_IMAGE: headerImage,
  RIGHT_CHEV_GRAY: rightChevGray,
  EOB_ICON: eobIcon,
  NO_DOCS: noDocs,
  RIGHT_INDICATOR: rightIndicator,
};
